const appName = document.title;

export default {
    beforeRouteEnter(to, from, next) {
        document.title = appName;
        next();
    },
    watch: {
        headTitle: {
            handler(title) {
                if (title) {
                    document.title = `${appName} | ${typeof title === 'function' ? title.call(this) : title}`;
                }
            },
            immediate: true,
        },
    },
};
